import TrueStrikeZone from "./TrueStrikeZone.js";

/**
 * Umpire decision is often based on some kind of universal strike zone, which is not adjusted for a taller batters.
 * This leads to solution based on universal strike zone, especially when pitcher data is being analyzed. 
 * @see https://docs.google.com/document/d/1GCQVVh6Ue0DrSiaHLYZ4zasDBxZSEi6kYt1aHgD_afo/edit#heading=h.l38dodwvtpxy
 * @see https://docs.google.com/document/d/1AP6qx2Y64D2CwIlOF_XzgDcUWDWQLfI1TCCBGx0GDko/edit#
 * @see http://tangotiger.net/strikezone/zone%20chart.png
 */
class UniversalStrikeZoneMLB extends TrueStrikeZone{
    constructor() {
        const ballSize = 3 * 0.0254;
        // NOTE, strike zone sizes are usually described as true strike zones, with the half of ball diameter included
        const strikeZoneBottom = 18 * 0.0254 + ballSize / 2;
        const strikeZoneTop = 42 * 0.0254 - ballSize / 2;
        const homePlateWidth = 17 * 0.0254;

        super(ballSize, homePlateWidth, strikeZoneBottom, strikeZoneTop);
    }
}

export default UniversalStrikeZoneMLB;